import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaWallet, FaCalendarAlt, FaEllipsisH, FaPlusCircle } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';

const BottomNavigation = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  // Don't show bottom nav on login, register, or admin pages
  const hideBottomNav = 
    !isAuthenticated ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/register') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/track/');

  if (hideBottomNav) {
    return null;
  }

  const isActive = (path) => {
    // Extract pathname and query from the path
    const [pathname, query] = path.split('?');
    
    if (pathname === '/') {
      return location.pathname === '/' && !location.search;
    }
    
    // Check if pathname matches
    if (location.pathname !== pathname) {
      return false;
    }
    
    // If there's a query parameter in the path, check if it matches
    if (query) {
      const params = new URLSearchParams(query);
      const locationParams = new URLSearchParams(location.search);
      for (const [key, value] of params.entries()) {
        if (locationParams.get(key) !== value) {
          return false;
        }
      }
    }
    
    return true;
  };

  const navItems = [
    {
      path: '/',
      label: 'Home',
      icon: FaHome,
      show: true
    },
    {
      path: '/earnings',
      label: 'Earnings',
      icon: FaWallet,
      show: user?.role === 'rider' // Only show for riders
    },
    {
      path: '/create-trip',
      label: 'Create Trip',
      icon: FaPlusCircle,
      show: user?.role === 'rider' // Only show for riders
    },
    {
      path: user?.role === 'rider' ? '/my-trips' : '/my-bookings',
      label: user?.role === 'rider' ? 'My Trips' : 'My Bookings',
      icon: FaCalendarAlt,
      show: true
    },
    {
      path: '/more',
      label: 'More',
      icon: FaEllipsisH,
      show: true
    }
  ].filter(item => item.show);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 md:hidden">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full relative ${
                active ? 'text-blue-600' : 'text-gray-500'
              }`}
            >
              <div className="relative">
                <Icon className={`text-xl ${active ? 'text-blue-600' : 'text-gray-500'}`} />
                {item.badge && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-xs mt-1 ${active ? 'text-blue-600 font-semibold' : 'text-gray-500'}`}>
                {item.label}
              </span>
              {active && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;

